<template>
  <div :class="['exchange', { inApp: $root.$data.isApp|| $root.miniprogram }]">
    <common-title titleName="纸质版卡片兑换" :zIndex="1000"></common-title>
    <div class="from_content">
      <div class="step2">
        <h2>请输入兑换码</h2>
        <van-field
          @input="getInpValue"
          v-model.trim="exchangeCard"
          type="input"
          placeholder="请输入"
        />
        <h3>激活说明</h3>
        <h4>1.刮开卡片的涂层并输入兑换码进行校验</h4>
        <h4>2.每个兑换码仅可领取一次电子卡，是领取电子卡的唯一凭证，请谨慎保管并及时领取</h4>
        <h4>3.该活动最终解释权归启航龙图教育科技有限公司所有</h4>
      </div>
    </div>
    <div class="fixedbottom">
      <div class="tmallBtn" :class="{ active: selected !== -1 }" @click="onClickTmall">
        点击激活
      </div>
    </div>
    <Loading ref="load" />
    <!-- 抽卡结果 -->
    <DrawCardSuccess
      ref="lotterySuccess"
      :lotteryRes="lotteryRes"
      :cardVOSList="cardVOSList"
      @continueLottry="continueLottry"
      :activityUserInfo="activityUserInfo"
    />
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import DrawCardSuccess from './component/drawCardSuccess.vue';
// eslint-disable-next-line import/no-cycle
import { reqActivationCode } from '@/api/collectCard/index';
import Loading from '@/components/loading/loading.vue';

export default {
  components: {
    CommonTitle,
    Loading,
    DrawCardSuccess,
  },
  data() {
    return {
      activityUserInfo: {}, // 用户参与集卡的数据
      cardVOSList: [], // 集卡信息
      lotteryRes: '', // 抽卡结果
      exchangeCard: '',
      selected: -1,
      onShow: false,
    };
  },

  computed: {},
  mounted() {
    document.title = '纸质版卡片兑换';
  },

  methods: {
    getInpValue() {
      if (this.exchangeCard) {
        this.selected = 0;
      } else {
        this.selected = -1;
      }
    },
    async onClickTmall() {
      if (this.selected === -1) {
        this.$toast('请输入兑换码');
        return;
      }
      this.$refs.load.show = true;
      const res = await reqActivationCode({ code: this.exchangeCard });
      if (res.code ===0) {
        this.$refs.load.show = false;
        this.lotteryRes = res.data?.cardCode;
        this.cardVOSList = [res.data];
        this.$refs.lotterySuccess.show = true;
        this.exchangeCard='';
        this.selected = -1;
        return;
      } else {
        this.$toast(res.msg);
      }
      this.$refs.load.show = false;
    },

    // 继续抽卡
    continueLottry() {},
  },
};
</script>

<style lang="scss" scoped>
.exchange {
  padding-top: 140px;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/exchangebg.png')
    no-repeat center;
  background-size: 100% 100%;
  .commonTitle {
    background-color: transparent !important;
  }
  &.inApp {
  padding-top: 10px;
}
}

.exchange {
  .from_content {
    width: 607px;
    background: #ffffff;
    border-radius: 14px;
    margin: 0 auto;
    padding: 47px 36px 54px 36px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.06);
    ::v-deep {
      .van-cell {
        padding: 0;
        .van-field__body {
          .van-field__control {
            height: 40px;
            padding-left: 16px;
            color: #333;
            font-weight: 400;
            font-size: 14px;
            background: #f8f9fb;
            border-radius: 10px;
          }
          input::-webkit-input-placeholder {
            color: #a5a5a5;
          }
        }
      }
    }
  }
  .step2 {
    h2 {
      margin-bottom: 48px;
      color: #333;
      font-weight: 500;
      font-size: 32px;
    }
    h3 {
      margin-top: 40px;
      color: #fc7e36;
      font-weight: 500;
      font-size: 28px;
      line-height: 40px;
      margin-block: 28px;
    }
    h4 {
      color: #999;
      font-weight: 400;
      font-size: 24px;
      line-height: 34px;
    }
  }
  .fixedbottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 167px;
    background: #ffffff;
    border-radius: 22px 22px 2px 2px;
    padding-top: 22px;
    .tmallBtn {
      width: 678px;
      height: 80px;
      line-height: 80px;
      background: #ff7f41;
      border-radius: 49px;
      margin: 0 auto;
      color: #fff;
      font-size: 32px;
      text-align: center;
      opacity: 0.5;
    }
  }

  .tmallBtn.active {
    opacity: 1;
  }
}
</style>
